import AddLeadToOpportunityModal from './addLeadToOppModal.view';

export default AddLeadToOpportunityModal;
